import { gql } from "@apollo/client";
import "../../api/types.js";
import { GqlRequestBuilder } from "../../api/GqlRequestBuilder.js";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
class BoUserGroupRequestBuilder extends GqlRequestBuilder {
  validateFilters() {
    return;
  }
  buildQuery(fields) {
    const requiredFields = ["id"];
    const queryFields = [.../* @__PURE__ */ new Set([...requiredFields, ...fields])];
    return gql`
            query GetBoUserGroups {
                getGroups {
                    items {
                        ${this.buildQueryFields(queryFields)}
                    }
                    total
                }
            }
        `;
  }
  buildFilter() {
    return {};
  }
}
export {
  BoUserGroupRequestBuilder
};
//# sourceMappingURL=requestBuilder.js.map
